import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { WhitelabelConfigStore } from '../config/whitelabel-config.store';

export interface ScheduleSearch {
  pickup: string | number;
  dropoff: string | number;
  traveldate: string;
  returning?: boolean;
  returndate?: string;
}

@Injectable({ providedIn: 'root' })
export class ScheduleRequestAdapter {
  constructor(private readonly configStore: WhitelabelConfigStore) {}

  buildParams(search: ScheduleSearch): HttpParams {
    let params = new HttpParams()
      .set('leaving_from', String(search.pickup))
      .set('going_to', String(search.dropoff))
      .set('departing_on', search.traveldate);

    if (search.returning && search.returndate) {
      params = params.set('return_date', search.returndate);
    }

    const contract = environment.scheduleOperatorContract;
    if (!contract.enabled) {
      return params;
    }

    const field = contract.queryParameter.trim();
    if (!field) {
      throw new Error(
        'Schedule operator filtering is enabled without a verified queryParameter.'
      );
    }

    const operatorIds = this.configStore.snapshot.config?.operatorIds ?? [];
    if (!operatorIds.length) {
      throw new Error(
        'Schedule operator filtering requires configured operator IDs.'
      );
    }

    if (contract.serialization === 'repeat') {
      return operatorIds.reduce(
        (result, operatorId) => result.append(field, operatorId),
        params
      );
    }

    return params.set(field, operatorIds.join(','));
  }
}
